import React, { Fragment } from 'react';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import { trans } from '../../../../localization';
import NowInput from '../../../../components/Common/NowInput';
import {
  NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD,
  NOW_PORTAL_DAILY_LEFTOVER_BALANCE,
} from '../../../../constants/constants';
import { formatCurrency } from '../../../../utils/utils';
import NowCheckbox from '../../../../components/Common/NowCheckbox';

class NowPortalEnableAutoTransferModal extends React.Component {
  state = {
    isSubmit: false,
    isKeepBalance: true,
    dailyMinThreshold: NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD,
    balance: NOW_PORTAL_DAILY_LEFTOVER_BALANCE,
    isShowOTPForm: false,
    otpCode: '',
  };

  resetState = () => {
    this.setState({
      isSubmit: false,
      isKeepBalance: true,
      dailyMinThreshold: NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD,
      balance: NOW_PORTAL_DAILY_LEFTOVER_BALANCE,
      isShowOTPForm: false,
      otpCode: '',
    });
  };

  handleKeepBalanceChange = (e) => {
    this.setState({ isKeepBalance: e.target.checked });
  };

  handleInputChange = name => (e) => {
    this.setState({
      [name]: e.target.value,
    });
  };

  toggleOTPForm = () => {
    const { isShowOTPForm } = this.state;
    this.setState({ isShowOTPForm: !isShowOTPForm });
  };

  handleRequestOTP = () => {
    this.setState({ isSubmit: true }, () => {
      const { dailyMinThreshold, isKeepBalance, balance } = this.state;
      const { enableAutoTransfer } = this.props;

      if (dailyMinThreshold < NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD) {
        return;
      }

      enableAutoTransfer({
        daily_min_threshold: dailyMinThreshold,
        daily_leftover_amount: isKeepBalance ? balance : undefined,
      }).then((isSuccess) => {
        if (isSuccess) {
          this.setState({ isShowOTPForm: true });
        }
      });
    });
  };

  handleSubmit = () => {
    const {
      dailyMinThreshold, isKeepBalance, balance, otpCode,
    } = this.state;
    const { enableAutoTransfer } = this.props;

    enableAutoTransfer(
      {
        daily_min_threshold: dailyMinThreshold,
        daily_leftover_amount: isKeepBalance ? balance : undefined,
      },
      otpCode || 'errorOTP',
    ).then((isSuccess) => {
      if (isSuccess) {
        this.handleClose();
      }
    });
  };

  handleClose = () => {
    const { onRequestClose } = this.props;
    onRequestClose();
    this.resetState();
  }

  renderAutoTransferForm = () => {
    const {
      dailyMinThreshold, isSubmit, isKeepBalance, balance,
    } = this.state;

    return (
      <div style={{ margin: 10 }}>
        <div className="modal-enable-auto-transfer-desc">{trans('rebranding.np_withdraw_auto_transfer_amount_desc')}</div>
        <NowInput
          value={dailyMinThreshold}
          onChange={this.handleInputChange('dailyMinThreshold')}
          placeholder={NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD}
          required={isSubmit}
          isNumberFormat
        />
        {isSubmit &&
          dailyMinThreshold < NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD && (
            <div className="error-min-threshold-message">
              {trans('np_withdraw_amount_invalid')}{' '}
              {formatCurrency(NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD)}.
            </div>
          )}
        <NowCheckbox
          id="keep-balance"
          value={isKeepBalance}
          name={trans('np_keep_balance')}
          onChange={this.handleKeepBalanceChange}
        />
        <NowInput
          value={balance}
          onChange={this.handleInputChange('balance')}
          placeholder={NOW_PORTAL_DAILY_LEFTOVER_BALANCE}
          required={isSubmit}
          isNumberFormat
          disabled={!isKeepBalance}
        />
      </div>
    );
  };

  renderOTPForm() {
    const { otpCode } = this.state;

    return (
      <div style={{ padding: 10 }}>
        <div className="enter-otp-desc">{trans('np_enter_otp_desc')}</div>
        <div className="input-otp-wrapper">
          <NowInput
            value={otpCode}
            onChange={this.handleInputChange('otpCode')}
            placeholder={trans('np_enter_verification_code')}
          />
          <button className="btn btn-white" onClick={this.handleRequestOTP}>
            {trans('np_resend_otp')}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { isOpen } = this.props;
    const { isShowOTPForm } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.handleClose}
        className="modal-enable-auto-transfer"
        zIndex={2}
      >
        <ModalHeader>{trans('np_enable_daily_withdraw')}</ModalHeader>
        <ModalBody>
          {!isShowOTPForm
            ? this.renderAutoTransferForm()
            : this.renderOTPForm()}
        </ModalBody>
        <ModalAction>
          {!isShowOTPForm ? (
            <Fragment>
              <ModalButton styleType="red" onClick={this.handleRequestOTP}>
                {trans('np_next')}
              </ModalButton>
              <ModalButton type="cancel" onClick={this.handleClose}>
                {trans('common_close')}
              </ModalButton>
            </Fragment>
          ) : (
            <Fragment>
              <ModalButton styleType="red" onClick={this.handleSubmit}>
                {trans('np_enable')}
              </ModalButton>
              <ModalButton type="cancel" onClick={this.handleClose}>
                {trans('common_close')}
              </ModalButton>
            </Fragment>
          )}
        </ModalAction>
      </Modal>
    );
  }
}

export default NowPortalEnableAutoTransferModal;



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalWithdraw/component/NowPortalEnableAutoTransferModal.jsx